<h1 multilang mat-dialog-title>Kundendaten erfassen</h1>
<div mat-dialog-content>
    <mat-button-toggle-group (change)="salutationChange($event)" style="margin: .5rem 0;">
        <mat-button-toggle multilang value="Herr">Herr</mat-button-toggle>
        <mat-button-toggle multilang value="Frau">Frau</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-form-field appearance="fill">
        <mat-label multilang>Name</mat-label>
        <input matInput multilang deeplMode='placeholder' [(ngModel)]="data.lastname">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label multilang>Vorname</mat-label>
        <input matInput multilang deeplMode='placeholder' [(ngModel)]="data.firstname">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label multilang>Telefon</mat-label>
        <input matInput multilang deeplMode='placeholder' [(ngModel)]="data.tel">
    </mat-form-field>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Abrechen</button>
    <button mat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Senden</button>
</div>